import StripeNoticeBar from "./StripeNoticeBar";

export * from ".";
export default StripeNoticeBar;